<script>
    import { Pie } from 'vue-chartjs'
    import palette from 'google-palette'
    let _ = require('lodash')

    export default {
        name: 'PieChart',
        extends: Pie,
        props: [
            'associativeArray',
            'multidimensionalArray',
            'countColumn',
            'labelColumn'
        ],
        mounted () {
            Chart.defaults.global.defaultFontFamily = 'Inter'
            Chart.defaults.global.defaultFontSize = 15
            this.renderChart(this.data)
        },
        computed: {
            data: function() {
                return this.computedData
            },
            computedData: function() {
                if (this.sourceArray) {
                    let labels = _.keys(this.sourceArray)
                    labels = _.transform(labels, (result, label, index) => {
                        return result[index] = _.upperFirst(label)
                    })
                    const values = _.values(this.sourceArray)
                    const datasets = [{
                        label: 'Data',
                        data: values,
                        backgroundColor: palette('sequential', values.length, 8).map(function(hex) {
                            return '#' + hex;
                        })
                    }]
                    return {
                        labels: labels,
                        datasets: datasets
                    }
                }
            },
            sourceArray: function() {
                return this.associativeArray ? this.associativeArray : this.multidimensionalToAssociative
            },
            multidimensionalToAssociative: function() {
                if(this.multidimensionalArray) {
                    return _.transform(this.multidimensionalArray, (result, data, index) => {
                        const count = data[this.countColumn]
                        const label = data[this.labelColumn]
                        return result[label] = count
                    })
                }
            }
        }
    }
</script>
